export default {
  init() {
    // JavaScript to be fired on the contact page
  },
  finalize() {

    $(document).on('click', '.drop-down-link', function() {

      if ( $(this).hasClass('active')) {
        $(this).siblings('.drop-down-content').slideUp(200);
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
        $(this).siblings('.drop-down-content').slideDown(200);
      }
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js